import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { getApiBaseUrl } from '../utils/api-base-url';

export interface InternalFileUploadResponse {
  fileId: number;
  fileName: string;
  url: string;
  message: string;
  alreadyExists: boolean;
}

/**
 * Uploads internal-only dashboard order-guide attachments. The bytes go to the separate "internal"
 * container and the metadata to cmt."File"; the API links the file to the vehicle. The attachment
 * category is fixed server-side, so the caller only supplies the file and vehicle.
 */
@Injectable({
  providedIn: 'root'
})
export class InternalFileUploadService {
  private readonly http = inject(HttpClient);

  upload(file: globalThis.File, vehicleId: number): Observable<InternalFileUploadResponse> {
    const form = new FormData();
    form.append('File', file, file.name);
    form.append('VehicleId', String(vehicleId));

    const url = `${getApiBaseUrl()}/api/InternalFileUpload/upload`;
    return this.http.post<InternalFileUploadResponse>(url, form).pipe(
      map((r) => ({
        ...r,
        alreadyExists: !!r.alreadyExists
      }))
    );
  }
}
